const userId = localStorage.getItem("uI");
const currentUser = userId - 786;


export default currentUser
